import { Helmet } from 'react-helmet-async'

import {
  Box, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import useAgency from '@hooks/useAgency'
import useBrand from '@hooks/useBrand'
import useCampaign from '@hooks/useCampaign'
import useOrderItems from '@hooks/useOrderItems'

import NotificationBannerLocation from '@components/NotificationBannerLocation'

import Footer from '@sections/Public/packs/Campaign/components/Footer'
import Header from '@sections/Public/packs/Campaign/components/Header'

import AgencyContactInfo from '@sections/Public/packs/Campaign/components/AgencyContactInfo'
import AgencyAndAgentsDetails from '@sections/Public/packs/Campaign/components/AgencyAndAgentsDetails'
import BrandedModuleHeader from '@sections/Public/packs/Campaign/components/BrandedModuleHeader'
import OrderItem from '../OrderItem'

interface PageContentProps {
  artworkIds: number[],
  campaignId: number,
}

const PageContent = (props: PageContentProps) => {
  const { artworkIds, campaignId } = props

  const campaignPayload = useCampaign({ id: campaignId })
  const {
    campaign: {
      agency_id,
      agent_ids,
      team_id,
    },
    loading,
  } = campaignPayload

  const agencyPayload = useAgency({ id: agency_id })
  const { agency, agency: { brand_id } } = agencyPayload

  const brandPayload = useBrand({ id: brand_id })
  const { brand, publicLinkTextAccentColour, publicLinkFontColor } = brandPayload
  // @ts-expect-error TS2339
  const brandPublicLinkCoverImageId = brand?.public_link_cover_image_id
  // @ts-expect-error TS2339
  const brandPublicLinkLogoId = brand?.public_link_logo_id
  const brandLegalDisclaimer = brand?.options?.branded_public_links?.legal_disclaimer

  const { filteredOrderItems, filteredOrderItemsCount } = useOrderItems({
    filters: { artwork_ids: artworkIds, campaign_id: campaignId },
    sortBy: 'id asc',
  })

  return (
    <>
      <Helmet>
        <title>Artwork Reviewer | Realhub</title>
      </Helmet>

      <Header campaignPayload={campaignPayload} coverImageId={brandPublicLinkCoverImageId} />

      <Box
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        marginTop={[-32, -64]}
        marginBottom="large"
        paddingX="large"
        position="relative"
        zIndex={10}
      >
        <Columns flexDirection={['column', 'column', 'row']} boxProps={{ maxWidth: ['100%', '900px'] }}>
          <Columns.Main marginRight="none" width={['100%', '900px']}>

            <NotificationBannerLocation locationKey="agency.artworkReviewer.campaign.banner" />

            <AgencyAndAgentsDetails
              agencyId={agency_id}
              agentIds={agent_ids || []}
              // @ts-expect-error
              brandId={brand_id}
              logoId={brandPublicLinkLogoId}
              teamId={team_id}
            />
          </Columns.Main>
        </Columns>
      </Box>

      <Box
        alignItems="center"
        backgroundColor="backgroundColor"
        flexDirection="column"
        justifyContent="center"
        paddingX="large"
        position="relative"
        zIndex={10}
      >
        <Columns
          flexDirection={['column', 'column', 'row']}
          boxProps={{ maxWidth: ['100%', '900px'], paddingTop: 'large' }}
        >
          {/*
           // @ts-expect-error TS2322 */}
          <Columns.Main marginRight="none" paddingX="large" width={['100%', '900px']}>
            <LoadingModule loading={loading} times={3} />

            <Box paddingX="large" flexDirection="column">
              <DashboardModule
                boxProps={{
                  border: 'none', marginTop: 'large', backgroundColor: 'backgroundColor',
                }}
                contentBoxProps={{ flexDirection: 'column' }}
                customHeader={(
                  <BrandedModuleHeader
                    accentColor={publicLinkTextAccentColour}
                    backgroundColour="backgroundColor"
                    title={`Artworks to Review (${filteredOrderItemsCount})`}
                  />
                )}
              />

              {!loading && filteredOrderItems.map(orderItem => (
                <OrderItem
                  accentColor={publicLinkTextAccentColour}
                  fontColor={publicLinkFontColor}
                  key={orderItem.id}
                  orderItem={orderItem}
                />
              ))}
            </Box>
          </Columns.Main>
        </Columns>
      </Box>

      {/*
       // @ts-expect-error TS2322 */}
      <AgencyContactInfo agency={agency} backgroundColor="white" />

      <Footer disclaimer={brandLegalDisclaimer} />
    </>
  )
}

export default PageContent
